import { jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const DisjointExpandIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 16),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: /*#__PURE__*/jsx("path", {
      d: "M15 4.8V1h-3.8M15 1l-4.2 4.2M1.1 11.2V15H5M1 15l4.2-4.2"
    })
  });
};

export { DisjointExpandIcon };
//# sourceMappingURL=expand.disjoint.js.map
